export const GET_ERRORS = 'GET_ERRORS';
export const CLEAR_ERRORS = 'CLEAR_ERRORS';

export const SET_CURRENT_USER = 'SET_CURRENT_USER';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const GET_CURR_USER = 'GET_CURR_USER';
export const REGISTER_REQUEST = 'REGISTER_REQUEST';
export const AUTH_LOADING = 'AUTH_LOADING';
export const LOGOUT = 'LOGOUT';
export const TRAINEE_CREATE_SUCCESS = 'TRAINEE_CREATE_SUCCESS';
export const TRAINEE_UPDATE_SUCCESS = 'TRAINEE_UPDATE_SUCCESS';
export const TRAINEE_DELETE = 'TRAINEE_DELETE';
export const UPDATE_AVATAR = 'UPDATE_AVATAR';
export const UPDATE_USER = 'UPDATE_USER';


export const ALERT_SUCCESS = 'ALERT_SUCCESS';
export const ALERT_ERROR = 'ALERT_ERROR';
export const ALERT_CLEAR = 'ALERT_CLEAR';


export const PROFILE_LOADING = 'PROFILE_LOADING';
export const SET_CURR_PROFILE = 'SET_CURR_PROFILE';
export const PROFILE_CREATE = 'PROFILE_CREATE';
export const UPDATE_PROFILE = 'UPDATE_PROFILE';
export const SET_CURR_TRAINEES = 'SET_CURR_TRAINEES';
export const TRINEE_PROFILE_CREATE = 'TRINEE_PROFILE_CREATE';
export const UPDATE_TRAINEES_LIST = 'UPDATE_TRAINEES_LIST';
export const DELETE_TRAINEE = 'DELETE_TRAINEE';


export const GET_MEETINGS = 'GET_MEETINGS';
export const MEETINGS_LOADING = 'MEETINGS_LOADING';
export const GET_FUTURE_MEETINGS = 'GET_FUTURE_MEETINGS';
export const CREATE_MEETING = 'CREATE_MEETING';
export const GET_ALL_MEETINGS = 'GET_ALL_MEETINGS';
export const SET_ALL_TRAINEES = 'SET_ALL_TRAINEES';
export const SET_ACTIVE_MEETING = 'SET_ACTIVE_MEETING';
export const GET_ACTIVE_MEETING = 'GET_ACTIVE_MEETING';
export const DELETE_MEETING = 'DELETE_MEETING';

export const CLEAR_PROFILE = 'CLEAR_PROFILE';
export const CLEAR_AUTH = 'CLEAR_AUTH';
export const CLEAR_MEETINGS = 'CLEAR_MEETINGS';
export const AUTH_PROFILE = 'AUTH_PROFILE';

export const SYNC_LOADING = 'SYNC_LOADING';
export const GET_CURR_SYNCS = 'GET_CURR_SYNCS';
export const CLEAR_SYNCS = 'CLEAR_SYNCS';

export const REC_LOADING = 'REC_LOADING';
export const GET_CURR_REC = 'GET_CURR_REC';
export const CLEAR_REC = 'CLEAR_REC';
export const UPDATE_AVATAR_TRAINEE = 'UPDATE_AVATAR_TRAINEE';
export const CLOSE_ACTIVE_MEETING = 'CLOSE_ACTIVE_MEETING';
export const SET_RECORDING = 'SET_RECORDING';
export const SET_MEETING_COMPKITED = 'SET_MEETING_COMPKITED';
export const SET_MEETING_COMPKITED_URL = 'SET_MEETING_COMPKITED_URL';
export const CLEARE_QUICK_MEETING = 'CLEARE_QUICK_MEETING';
export const UPCOMING_MEETING_UPDATE = 'UPCOMING_MEETING_UPDATE';

export const SYNC_PERFORM_LOADING = 'SYNC_PERFORM_LOADING';
export const CLEAR_SYNC_PERFORM = 'CLEAR_SYNC_PERFORM';
export const GET_CURR_SYNC_PERFORM = 'GET_CURR_SYNC_PERFORM';
export const CREATE_MEETING_SYNC = 'CREATE_MEETING_SYNC';
export const GET_TRAINEES_SYNC_PERFORM = 'GET_TRAINEES_SYNC_PERFORM';
//export const  = '';
//export const  = '';
//export const  = '';
//export const  = '';
//export const  = '';
//export const  = '';







